export const addNewPromo = {
    computed: {
        form() {
            return this.$store.getters.getNewPromoForm
        },
        isMix() {
            return this.$store.getters.isNewPromoTypeMix
        },
        isTypeWeight() {
            return this.$store.getters.isNewPromoTypeWeight
        },
        selectedProducts() {
            if (this.isMix) {
                return this.form.step3.product_sets[0].products.value
            } else {
                return this.form.step3.products.value
            }
        },
        selectedMerchants() {
            return this.form.step2.merchants.value
        },
        recentlySelectedProductIds() {
            return this.$store.getters.getRecentlySelectedProducts
        },
        limits() {
            return this.$store.getters.getNetworksLimits
        },
        merchantsWithAvailableLimit() {
            return this.limits?.filter(merchant => {
                return (
                    +merchant.active_promotions <
                    +merchant.retailer_promos_limit
                )
            })
        },
        availableMerchantsIncludeSelected() {
            const a = this.selectedMerchants.map(el => el.id)
            const b = (this.merchantsWithAvailableLimit || []).map(
                el => el.merchant_id
            )
            return a.every(v => {
                return b.includes(v)
            })
        },
        productsLimit() {
            if (this.limits) {
                const selectedMerchantIds = this.selectedMerchants.map(
                    el => el.id
                )
                const filteredLimits = this.limits
                    .filter(el => selectedMerchantIds.includes(el.merchant_id))
                    .map(el => el.retailer_promo_products_limit)
                const limit = Math.min(...filteredLimits)
                return limit
            }
        },
        isProductsLimitReached() {
            return this.selectedProducts.length >= this.productsLimit
        },
        isClearProductsDisabled() {
            if (this.isMix) {
                return this.form.step3.product_sets.some(
                    set => !set.products.value.length
                )
            } else {
                return !this.form.step3.products.value.length
            }
        },
        isClearFormStep1Disabled() {
            const initForm = JSON.parse(this.initForm)
            return (
                JSON.stringify(this.form.step1) ===
                JSON.stringify(initForm?.step1)
            )
        },
        steps() {
            return this.$store.getters.getNewPromoSteps
        },
        isEveryLocationAboutToClose() {
            return this.$store.getters.isEveryLocationAboutToClose
        },
        latestLocationClosingDate() {
            return this.$store.getters.getLatestLocationClosingDate
                ? this.$moment(this.$store.getters.getLatestLocationClosingDate)
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD HH:mm:ss')
                : null
        },
        startAtLockFutureDays() {
            const endAt = this.form.step1.end_at.value
            const dates = [endAt]
            if (this.isEveryLocationAboutToClose) {
                dates.push(this.latestLocationClosingDate)
            }
            return dates
        },
        endAtLockFutureDays() {
            if (this.isEveryLocationAboutToClose) {
                return [this.latestLocationClosingDate]
            }
        }
    },
    methods: {
        disableNextSteps(wantedIndex) {
            const steps = []
            this.steps.forEach((step, idx) => {
                if (idx >= wantedIndex) {
                    step.disabled = true
                }
                steps.push(step)
            })
            this.$store.dispatch('setAddNewPromoSteps', steps)
        },
        toggleProduct(product, setIdx) {
            const form = JSON.parse(JSON.stringify(this.form))
            let isProductAdded = false

            if (typeof setIdx === 'number') {
                const isProductInArray = form.step3.product_sets[
                    setIdx
                ].products.value.find(prod => prod.id === product.id)

                if (isProductInArray) {
                    form.step3.product_sets[
                        setIdx
                    ].products.value = form.step3.product_sets[
                        setIdx
                    ].products.value.filter(prod => prod.id !== product.id)
                } else {
                    const prod = this.setProductMerchantPricesSlot(
                        product,
                        this.isMix
                    )
                    form.step3.product_sets[setIdx].products.value.push(prod)
                    this.$store.dispatch('setAddNewPromoForm', form)
                    isProductAdded = true
                }

                // reset errors
                form.step3.product_sets[setIdx].invalid = ''
            } else {
                const isProductInArray = form.step3.products.value.find(
                    prod => prod.id === product.id
                )

                if (isProductInArray) {
                    form.step3.products.value = form.step3.products.value.filter(
                        prod => prod.id !== product.id
                    )
                } else {
                    const prod = this.setProductMerchantPricesSlot(
                        product,
                        this.isMix
                    )
                    const prods = JSON.parse(
                        JSON.stringify(form.step3.products.value)
                    )
                    prods.push(prod)
                    this.$set(form.step3.products, 'value', prods)
                    isProductAdded = true
                }

                // reset errors
                form.step3.invalid = ''
            }

            this.$store.dispatch('setAddNewPromoForm', form)
            return isProductAdded
        },
        setProductMerchantPricesSlot(product, isMix) {
            const merchants = JSON.parse(JSON.stringify(this.selectedMerchants))
            product.merchant_prices = []
            merchants.forEach(merchant => {
                if (isMix) {
                    product.merchant_prices.push({
                        merchant_id: merchant.id,
                        normal_price: 0,
                        temp_id: product.id
                    })
                } else {
                    product.merchant_prices.push({
                        alternative_ean: null,
                        merchant_id: merchant.id,
                        promo_price: 0,
                        normal_price: 0,
                        temp_id: product.id
                    })
                }
            })
            return product
        },
        onPromoPriceChange(merchantId, price, productId) {
            const product = this.selectedProducts.find(
                prod => prod.id === productId
            )
            product.merchant_prices.find(
                merchant => merchant.merchant_id === merchantId
            ).promo_price = price
        },
        onLocalCodeChange(merchantId, code, productId) {
            const product = this.selectedProducts.find(
                prod => prod.id === productId
            )

            product.merchant_prices.find(
                merchant => merchant.merchant_id === merchantId
            ).alternative_ean = code

            this.form.step3.products.value = this.form.step3.products.value.filter(
                prod => prod.id
            )
        },
        onNormalPriceChange(merchantId, price, productId) {
            const product = this.selectedProducts.find(
                prod => prod.id === productId
            )
            product.merchant_prices.find(
                merchant => merchant.merchant_id === merchantId
            ).normal_price = price
        },
        setPriceObjects() {
            if (this.isMix) {
                const merchantIds = this.selectedMerchants.map(m => m.id)
                this.selectedMerchants.forEach(sMerchant => {
                    this.form.step3.product_sets.forEach(set => {
                        set.price.value = set.price.value.filter(merchant =>
                            merchantIds.includes(merchant.merchant_id)
                        )
                        const findMerchantPrice = set.price.value.find(
                            mPrice => mPrice.merchant_id === sMerchant.id
                        )
                        if (!findMerchantPrice) {
                            set.price.value.push({
                                merchant_id: sMerchant.id,
                                price: 0
                            })
                        }
                    })
                })
            } else {
                if (this.selectedProducts) {
                    const merchantIds = this.selectedMerchants.map(m => m.id)
                    this.selectedProducts.forEach(product => {
                        product.merchant_prices = product.merchant_prices.filter(
                            merchant =>
                                merchantIds.includes(merchant.merchant_id)
                        )
                        this.selectedMerchants.forEach(merchant => {
                            const isMerchant = product.merchant_prices.find(
                                m => m.merchant_id === merchant.id
                            )
                            if (!isMerchant) {
                                product.merchant_prices.push({
                                    alternative_ean: null,
                                    merchant_id: merchant.id,
                                    promo_price: 0,
                                    normal_price: 0,
                                    temp_id: product.id
                                })
                            }
                        })
                    })
                }
            }
        },
        openProductSetPrices(setIdx) {
            this.form.step3.product_sets[setIdx].price.invalid = ''
            this.$store.dispatch('openModal', {
                component: 'ProductSetPrices',
                args: {
                    setIdx
                }
            })
        },
        openProductPrices(product, setIdx) {
            if (typeof setIdx === 'number') {
                this.form.step3.product_sets[setIdx].invalid = ''
            } else {
                this.form.step3.invalid = ''
            }
            this.$store.dispatch('openModal', {
                component: 'ProductPrices',
                args: {
                    product
                }
            })
        },
        openProductsModal(setIdx) {
            const productParams = {
                available_in_promos: this.isTypeWeight ? 'weight' : 'piece',
                ean_present: this.isTypeWeight ? false : undefined
            }

            if (this.isMix) {
                productParams.ean_present = true
            }

            this.$store.dispatch('openModal', {
                component: 'AddPromoSelectionProducts',
                args: {
                    setIdx,
                    params: {
                        ...productParams
                    }
                }
            })
        },
        chooseMainImage(product, value) {
            this.form.step3.invalid = ''
            if (value) {
                this.form.step3.main_image_dict_product_id.value = product?.id
            } else {
                if (
                    this.form.step3.main_image_dict_product_id.value ===
                    product?.id
                ) {
                    this.form.step3.main_image_dict_product_id.value = null
                }
            }
            this.saveFormToStorage()
        },
        saveFormToStorage() {
            if (this.$store.getters.getWalkthroughActive) return
            this.$store.$storage.setItem('addNewPromoForm', this.form)
        },
        validateFormDates() {
            const now = this.$moment()
            const startAt = this.form.step1.start_at.value
            const endAt = this.form.step1.end_at.value
            if (startAt) {
                const start = this.$moment(startAt.slice(0, 10) + 'T00:00:00')
                if (now.isAfter(start)) {
                    this.form.step1.start_at.value = this.$moment().format(
                        'YYYY-MM-DD'
                    )
                }
            }
            if (endAt) {
                const end = this.$moment(endAt.slice(0, 10) + 'T23:59:00')
                if (now.isAfter(end)) {
                    this.form.step1.end_at.invalid =
                        'Data musi wypadać w przyszłości'
                    this.changeStep(0)
                    return false
                }
            }
            return true
        },
        validateMerchants() {
            if (this.limits) {
                const overLimitedMerchants = this.limits
                    .filter(
                        el => +el.active_promotions >= +el.retailer_promos_limit
                    )
                    .map(el => el.merchant_id)

                const selectedOverLimitedMerchants = this.selectedMerchants.filter(
                    el => overLimitedMerchants.includes(el.id)
                )
                if (selectedOverLimitedMerchants.length) {
                    this.changeStep(1)
                    this.form.step2.merchants.invalid =
                        'Osiągnięto limit promocji własnych w co najmniej jednym wybranym sklepie'
                    return false
                }
            }
            return true
        },
        isLatestClosingDateBeforePromoStart() {
            if (this.$store.getters.isEveryLocationAboutToClose) {
                const latestClosingDateBeforePromoStart = this.$moment(
                    this.latestLocationClosingDate
                )
                    .add(1, 'days')
                    .isBefore(this.$moment(this.form.step1.start_at.value))
                if (latestClosingDateBeforePromoStart) {
                    this.setInvalidDateFeedback('start_at')
                }
                return latestClosingDateBeforePromoStart
            } else {
                return false
            }
        },
        isLatestClosingDateBeforePromoEnd() {
            if (this.$store.getters.isEveryLocationAboutToClose) {
                const latestClosingDateBeforePromoEnd = this.$moment(
                    this.latestLocationClosingDate
                )
                    .add(1, 'days')
                    .isBefore(this.$moment(this.form.step1.end_at.value))
                if (latestClosingDateBeforePromoEnd) {
                    this.setInvalidDateFeedback('end_at')
                }
                return latestClosingDateBeforePromoEnd
            } else {
                return false
            }
        },
        setInvalidDateFeedback(value) {
            this.form.step1[
                value
            ].invalid = `Nie możesz wybrać daty po ${this.$moment(
                this.latestLocationClosingDate
            )
                .add(1, 'days')
                .format(
                    'DD-MM-YYYY'
                )} ponieważ żadne sklepy nie będą po tej dacie aktywne`
        },
        validateMerchantsClosingDates() {
            const currentIdx = this.steps.findIndex(el => !!el.active)
            const merchants = currentIdx === 0
                ? this.$store.getters.getAvailableMerchants
                : this.selectedMerchants

            if (!merchants.length) {
                return
            }

            const errors = []
            const promoEnd = this.form.step1.end_at.value

            merchants.forEach(({ location_id }) => {
                const userLoc = this.$store.getters.getUserLocationById(location_id)
                const closingData = userLoc?.closing_date

                if (closingData) {
                    if (this.$moment(closingData).isBefore(this.$moment(promoEnd))) {
                        errors.push(userLoc)
                    }
                }
            })

            if (errors.length) {
                this.form.step2.merchants.invalid = 'Data obowiązywania promocji wykracza poza datę wypowiedzenia sklepu w co najmniej jednym wybranym sklepie'
            }

            // If errors, return false
            return !errors.length
        },
        async getFormFromStorage() {
            const form = await this.$store.$storage.getItem('addNewPromoForm')
            if (form) {
                this.$store.dispatch('setAddNewPromoForm', form)
            }
        },
        saveStepsToStorage() {
            if (this.$store.getters.getWalkthroughActive) return
            this.$store.$storage.setItem('addNewPromoSteps', this.steps)
        },
        async getStepsFromStorage() {
            const steps = await this.$store.$storage.getItem('addNewPromoSteps')
            if (steps) this.$store.dispatch('setAddNewPromoSteps', steps)
        },
        validatePromoMarketings() {
            if (this.form.step1.marketing_id.value) {
                if (
                    !this.$store.getters.getNewPromoMarketingsForSelect
                        .map(e => e.value)
                        .includes(this.form.step1.marketing_id.value)
                ) {
                    this.form.step1.marketing_id.value = ''
                    this.form.step1.marketing_id.invalid =
                        'Wybierz odpowiednią komunikację marketingową'
                } else {
                    this.form.step1.marketing_id.invalid = ''
                }
            }
        },
        isAnyNoEanProduct(products) {
            return products.some(product => !product.ean_present)
        }
    },
    watch: {
        selectedMerchants() {
            this.setPriceObjects()
            this.form.step2.merchants.invalid = ''
        },
        form: {
            handler(newVal, oldVal) {
                this.saveFormToStorage()
            },
            deep: true
        },
        steps: {
            handler() {
                this.saveStepsToStorage()
            },
            deep: true
        }
    }
}
